import React, { useEffect, useState } from "react"

import { detectLanguage } from "../../utils/utils"
import { withRouter } from 'react-router-dom';
import Constants from "../../utils/constants"

import "./styles.scss"

const PublicNotice = (props) => {
  const { LANGUAGES } = Constants
  const { maintenance, distruption } = LANGUAGES

  const [settings, setSettings] = useState(props.settings)
  const [lang, setLang] = useState(props.lang)

  useEffect(() => {
    setSettings(props.settings && props.settings.length > 0 ? props.settings[0] : null)
  }, [props.settings])

  if (settings && (settings.publicNoticesZh || settings.publicNoticesEn)) {
    return (
      <div className="public-notice">
        {settings[`publicNotices${lang.charAt(0).toUpperCase() + lang.slice(1)}`]}
      </div>
    )
  } else if (settings && settings.maintenance) {
    return (
      <div className="public-notice">
        {maintenance[lang]}
      </div>
    )
  } else if (settings && settings.publicDisruption) {
    return (
      <div className="public-notice">
        {distruption[lang]}
      </div>
    )
  } else {
    return null
  }
}

export default withRouter(PublicNotice)